import React from 'react';
import PropTypes from 'prop-types';

import FormControlContext from 'src/app/components/FormControl/FormControlContext';
import 'src/app/components/FormControl/FormControl.scss';


const Input = React.forwardRef(({ required, type, ...other }, ref) =>
  <FormControlContext.Consumer>
    {(context) =>
      <input styleName="form-control__input"
             { ...{ required, type, ref } }
             { ...other }
             value={ context.value }
             disabled={ !!context.disabled }
      />
    }
  </FormControlContext.Consumer>
);

Input.propTypes = {
  required: PropTypes.bool,
  type: PropTypes.string,
  other: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

Input.defaultProps = {
  required: false,
  type: '',
  other: {}
};

export default Input;
